import React, { Component } from "react";
import { Row, FormGroup, Label, Button } from "reactstrap";
import { Field, FieldArray, Form, Formik } from "formik";
import SimpleReactValidator from "simple-react-validator";

import { DANGER, SUBMIT, SUCCESS, UPDATE } from "constants/commonConstants";
import { toastrMessage } from "helpers/messageHelper";

import {
  getDeliveryChargesSlabsRequest,
  updateDeliveryChargesSlabsRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { makeSiteSettingSelectField } from "store/SiteSetting/selector";
import { createStructuredSelector } from "reselect";

class DeliveryChargesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operationType: UPDATE,
      deliveryChargesData: deliveryChargesDataInitialState(),
      editable: false,
    };
    this.validatorArr = [new SimpleReactValidator()];
  }

  componentDidMount() {
    //Retrieve category list
    this.props.getDeliveryChargesSlabsRequest();
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.deliveryChargesData &&
      this.props.deliveryChargesData !== nextprops.deliveryChargesData
    ) {
      const deliveryChargesData = deliveryChargesDataInitialState();
      if (nextprops.deliveryChargesData.length > 0) {
        deliveryChargesData.deliveryChargesData = nextprops.deliveryChargesData;
        this.setState({
          deliveryChargesData,
        });
        this.validatorArr = Array.from(
          { length: nextprops.deliveryChargesData.length },
          () => new SimpleReactValidator()
        );
      }
    }
    if (
      nextprops.deliveryChargesApiResponse &&
      this.props.deliveryChargesApiResponse !==
        nextprops.deliveryChargesApiResponse
    ) {
      if (nextprops.deliveryChargesApiResponse.isSuccessResponse) {
        this.props.getDeliveryChargesSlabsRequest();
        toastrMessage(
          nextprops.deliveryChargesApiResponse.responseMessage,
          SUCCESS
        );
        this.setState({
          editable: false,
          operationType: UPDATE,
        });
      } else if (!nextprops.deliveryChargesApiResponse.isSuccessResponse) {
        toastrMessage(
          nextprops.deliveryChargesApiResponse.responseMessage,
          DANGER
        );
      }
    }
  }

  handleAddElement = (arrayHelpers, idx) => {
    if (this.validatorArr[idx].allValid()) {
      arrayHelpers.insert(idx + 1, {
        ...deliveryChargesDataInitialState().deliveryChargesData[0],
      });
      this.validatorArr.push(new SimpleReactValidator());
      this.validatorArr[idx].hideMessages();
    } else {
      this.validatorArr[idx].showMessages();
      this.forceUpdate();
    }
  };

  handleRemoveElement = (arrayHelpers, idx) => {
    arrayHelpers.remove(idx);
    // remove element from the state variable
    const { deliveryChargesData } = this.state;
    deliveryChargesData.deliveryChargesData.splice(idx, 1);
    this.validatorArr.splice(idx, 1);
    this.setState({
      deliveryChargesData,
    });
  };

  handleCancelClick = () => {
    this.props.getDeliveryChargesSlabsRequest();
    this.setState({
      editable: false,
      operationType: UPDATE,
    });
  };

  formSubmit = (values) => {
    if (this.state.editable) {
      const deliveryChargesData = values.deliveryChargesData;

      const fieldsValid = this.validatorArr.filter((v) => {
        if (v.allValid()) {
          v.hideMessages();
          return true;
        }
        v.showMessages();
        return false;
      });
      if (fieldsValid.length === this.validatorArr.length) {
        if (deliveryChargesData.length > 0) {
          this.props.updateDeliveryChargesSlabsRequest(deliveryChargesData);
        }
      } else {
        this.forceUpdate();
      }
    } else {
      this.setState({
        editable: true,
        operationType: SUBMIT,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Formik
          initialValues={this.state.deliveryChargesData}
          enableReinitialize={true}
          onSubmit={this.formSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form className="mt-3">
              <FieldArray
                name="deliveryChargesData"
                render={(arrayHelpers) => (
                  <div>
                    {values.deliveryChargesData &&
                    values.deliveryChargesData.length > 0
                      ? values.deliveryChargesData.map((item, idx) => (
                          <Row key={idx}>
                            <FormGroup className="col-6 col-sm">
                              <Label className="mb-0">Min Amt</Label>
                              <Field
                                name={`deliveryChargesData[${idx}].minAmt`}
                                type="number"
                                className="form-control"
                                disabled={!this.state.editable}
                                min="0"
                              ></Field>
                              {this.validatorArr[idx].message(
                                "Min Amt",
                                values.deliveryChargesData[idx].minAmt,
                                "required|numeric|min:0,num"
                              )}
                            </FormGroup>
                            <FormGroup className="col-6 col-sm">
                              <Label className="mb-0">Max Amt</Label>
                              <Field
                                name={`deliveryChargesData[${idx}].maxAmt`}
                                type="number"
                                className="form-control"
                                disabled={!this.state.editable}
                                min="0"
                              ></Field>
                              {this.validatorArr[idx].message(
                                "Max Amt",
                                values.deliveryChargesData[idx].maxAmt,
                                "required|numeric|min:0,num"
                              )}
                            </FormGroup>
                            <FormGroup className="col-6 col-sm">
                              <Label className="mb-0">Delivery Charges</Label>
                              <Field
                                name={`deliveryChargesData[${idx}].deliveryCharges`}
                                type="number"
                                className="form-control"
                                disabled={!this.state.editable}
                                min="0"
                              ></Field>
                              {this.validatorArr[idx].message(
                                "Delivery Charges",
                                values.deliveryChargesData[idx].deliveryCharges,
                                "required|numeric|min:0,num"
                              )}
                            </FormGroup>

                            <FormGroup
                              className="d-flex align-items-center flex-shrink-1"
                              style={{ width: "70px" }}
                            >
                              {this.state.editable ? (
                                <>
                                  {values.deliveryChargesData.length > 1 ? (
                                    <Button
                                      type="button"
                                      color="secondary"
                                      className="mr-1 px-2 py-1 rounded-circle"
                                      onClick={() =>
                                        this.handleRemoveElement(
                                          arrayHelpers,
                                          idx
                                        )
                                      }
                                    >
                                      <i className="fas fa-minus"></i>
                                    </Button>
                                  ) : null}

                                  {values.deliveryChargesData.length ===
                                  idx + 1 ? (
                                    <Button
                                      type="button"
                                      color="primary"
                                      className="mr-1 px-2 py-1 rounded-circle"
                                      onClick={() =>
                                        this.handleAddElement(arrayHelpers, idx)
                                      } // insert an empty string at a position
                                    >
                                      <i className="fas fa-plus"></i>{" "}
                                    </Button>
                                  ) : null}
                                </>
                              ) : null}
                            </FormGroup>
                          </Row>
                        ))
                      : null}
                  </div>
                )}
              />
              <div className="d-flex justify-content-end">
                <Button type="submit" color="primary" className="mr-2">
                  {this.state.operationType}
                </Button>
                {this.state.editable && (
                  <Button
                    type="button"
                    color="secondary"
                    onClick={this.handleCancelClick}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  deliveryChargesData: makeSiteSettingSelectField("deliveryChargesData"),
  deliveryChargesApiResponse: makeSiteSettingSelectField(
    "deliveryChargesApiResponse"
  ),
});

const withConnect = connect(mapStatetoProps, {
  getDeliveryChargesSlabsRequest,
  updateDeliveryChargesSlabsRequest,
});

export default compose(withConnect, withRouter)(DeliveryChargesList);

function deliveryChargesDataInitialState() {
  return {
    deliveryChargesData: [
      {
        minAmt: "",
        maxAmt: "",
        deliveryCharges: "",
      },
    ],
  };
}
